/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { useQuery } from "@tanstack/react-query";
import { getMaterialLosses } from "./materialsLossesFunctions";

export function useMaterialLosses(startDate: string, endDate: string) {
    return useQuery({
        queryKey: ["MATERIALS", "LOSSES", startDate, endDate],
        queryFn: () => getMaterialLosses(startDate, endDate),
        select: ({ data }) => data,
    });
}
